import { NotifyHelper } from "../../../helpers/toast";
import { eDiemQuyDoiActionsObj } from "../../action-types/category/IDiemQuyDoiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const diemQuyDoiActions = {
    ...generateActions(eDiemQuyDoiActionsObj, "DIEM_QUY_DOI"),
    ...generateActionForKey(eDiemQuyDoiActionsObj, "DIEM_QUY_DOI", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eDiemQuyDoiActionsObj, "DIEM_QUY_DOI", "DELETE_SUCCESS", () => { NotifyHelper.Success("thành công") }),
    ...generateActionForKey(eDiemQuyDoiActionsObj, "DIEM_QUY_DOI", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eDiemQuyDoiActionsObj, "DIEM_QUY_DOI", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}